<h2 mat-dialog-title><svg-icon src="/assets/icons/icon-40-attention.svg"></svg-icon> Move project to archive</h2>

<h3>All active components will be removed from the project,</h3>
<p>All data from the project will still be available</p>
<mat-dialog-actions>
  <button mat-flat-button [mat-dialog-close]="false" (click)="onCancel()">Cancel</button>
  <button mat-flat-button mat-primary [mat-dialog-close]="true" color="primary">Move to archive</button>
</mat-dialog-actions>
